import React, { useEffect } from 'react';
import ROUTES from '../../shared/constants/routes';
import { useNavigate } from 'react-router-dom';
import ChatComplete from '../../components/organisms/ChatAI/components/ChatComplete';
import { Headset } from '@phosphor-icons/react';
import { Conversation } from '../../@types/IA.type';
import useGrowthbookExperiment from '../../hooks/useGrowthbookExperiment';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import SupportFormPage from '../supportFormPage';
import { EVENT_TYPES } from '../../shared/constants/events';
import usePageView from '../../hooks/usePageView';

const initialOptions = [
	{
		label: 'Vinculación fiscal',
		message: `¿Como puedo vincular mi RFC a heru?`,
	},
	{
		label: 'Estado del servicio',
		message: `¿Donde veo el estado de los servicios que tengo contratados con heru?`,
	},
	{
		label: 'Hablar con un agente',
		message: 'Hola quiero hablar con un agente para resolver una duda',
	},
];

const SupportPage: React.FC = () => {
	const navigate = useNavigate();
	const { showChatAI } = useGrowthbookExperiment();
	const { user: userProfile } = useSelector((state: RootState) => state.profile);

	const { trackPageView } = usePageView({
		sectionVisit: EVENT_TYPES.PAGE_VIEW_SUPPORT
	});

	useEffect(() => {
		trackPageView();
	}, []);

	const defaultInitialMessage: Conversation = {
		id: 0,
		user_id: 0,
		thread: [
			{
				role: 'assistant',
				content: `Hola ${userProfile?.first_name}, soy Mr. Tax, tu asistente personal de IA en heru y estoy aquí para ayudarte con dudas relacionadas a tus servicios, nuestros planes o nuestra plataforma. ¡Estoy atento a tus dudas!`,
			},
		],
		created_at: new Date(),
		updated_at: new Date(),
	};

	if (!showChatAI) {
		return <SupportFormPage />;
	}

	return (
		<div className='fade-in max-w-[800px] fixed md:relative top-0 md:top-auto left-0 md:left-auto z-[999] md:z-0 mx-auto h-[100dvh] md:h-full md:pt-12 fade-in-scale'>
			<div className='flex flex-col flex-1 h-full overflow-hidden'>
				<div className='bg-white rounded-t-2xl flex items-center gap-2 p-2 justify-center border-2 border-h-neutral-94'>
					Soporte
					<Headset weight='bold' />
				</div>
				<ChatComplete
					containerStyles='!rounded-none !shadow-none'
					handleClose={() => navigate(ROUTES.ROOT)}
					initialMessage={defaultInitialMessage}
					initialOptions={initialOptions}
					chatName='Mr. Tax'
				/>
			</div>
		</div>
	);
};

export default SupportPage;
